<div class="plans-page" [class.plans-page--embed]="embedMode">

  <!-- Hero Section -->
  <div class="hero-section text-center" *ngIf="!embedMode">
    <h1 class="hero-title">
      {{ curentLang === 'en' ? 'Choose the right plan for your business' : (curentLang === 'ar' ? 'اختر الخطة المناسبة لعملك' : 'בחר את התוכנית המתאימה לעסק שלך') }}
    </h1>
    <p class="hero-subtitle">
      {{ curentLang === 'en' ? 'Manage invoices, companies and expenses with smart tools powered by AI' : (curentLang === 'ar' ? 'أدر فواتيرك ومصالح تجاريةك ومصاريفك بأدوات ذكية مدعومة بالذكاء الاصطناعي' : 'נהל חשבוניות, חברות והוצאות עם כלים חכמים מונעי AI') }}
    </p>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-grow text-danger" role="status"></div>
    <p class="text-muted mt-2 mb-0">{{ curentLang === 'en' ? 'Loading plans…' : (curentLang === 'ar' ? 'جاري تحميل الخطط…' : 'טוען תוכניות…') }}</p>
  </div>

  <!-- Error -->
  <div *ngIf="loadError && !loading" class="text-center py-5">
    <div class="error-card mx-auto">
      <i class="fa fa-exclamation-triangle text-danger fa-2x mb-3"></i>
      <p style="color: #444;">{{ curentLang === 'en' ? 'Could not load plans.' : (curentLang === 'ar' ? 'تعذر تحميل الخطط.' : 'לא ניתן לטעון תוכניות.') }}</p>
      <button class="btn brand-btn btn-sm" (click)="loadAll()">
        <i class="fa fa-refresh me-1"></i>{{ curentLang === 'en' ? 'Retry' : (curentLang === 'ar' ? 'إعادة المحاولة' : 'נסה שוב') }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="!loading && !loadError">

    <!-- ═══════════════════════════════════════════ -->
    <!--  SECTION 1: Invoice Subscription Plans      -->
    <!-- ═══════════════════════════════════════════ -->
    <section class="plans-section">
      <div class="section-header">
        <div class="section-icon invoice-icon"><i class="fa fa-file-text"></i></div>
        <div>
          <h2 class="section-title">{{ curentLang === 'en' ? 'Invoice Plans' : (curentLang === 'ar' ? 'خطط الفواتير' : 'תוכניות חשבוניות') }}</h2>
          <p class="section-desc">{{ curentLang === 'en' ? 'Full-featured subscription plans for invoicing & document management' : (curentLang === 'ar' ? 'خطط اشتراك متكاملة لإدارة الفواتير والمستندات' : 'תוכניות מנוי מלאות לניהול חשבוניות ומסמכים') }}</p>
        </div>
      </div>

      <div class="row g-4 justify-content-center">
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of subscriptionPlans; let i = index">
          <div class="plan-card" [class.plan-card--featured]="i === 1">
            <div class="plan-card__badge" *ngIf="i === 1">
              {{ curentLang === 'en' ? 'Popular' : (curentLang === 'ar' ? 'الأكثر طلبًا' : 'פופולרי') }}
            </div>
            <div class="plan-card__header">
              <h3 class="plan-card__name">{{ planName(plan) }}</h3>
              <p class="plan-card__desc" *ngIf="planDesc(plan)">{{ planDesc(plan) }}</p>
            </div>
            <div class="plan-card__price">
              <span class="plan-card__currency">₪</span>
              <span class="plan-card__amount">{{ plan.price | number:'1.0-0' }}</span>
              <span class="plan-card__period">/ {{ plan.duration_days }} {{ curentLang === 'en' ? 'days' : (curentLang === 'ar' ? 'يوم' : 'ימים') }}</span>
            </div>
            <ul class="plan-card__features">
              <li><i class="fa fa-file-o"></i> {{ plan.documents_limit }} {{ curentLang === 'en' ? 'documents' : (curentLang === 'ar' ? 'مستند' : 'מסמכים') }}</li>
              <li><i class="fa fa-building-o"></i> {{ plan.companies_limit }} {{ curentLang === 'en' ? 'companies' : (curentLang === 'ar' ? 'مصالح تجارية' : 'חברות') }}</li>
              <li><i class="fa fa-calendar"></i> {{ plan.duration_days }} {{ curentLang === 'en' ? 'days validity' : (curentLang === 'ar' ? 'يوم صلاحية' : 'ימי תוקף') }}</li>
              <li *ngIf="plan.analysis_tokens_limit != null"><i class="fa fa-magic"></i> {{ plan.analysis_tokens_limit }} {{ curentLang === 'en' ? 'AI expense analysis tokens' : (curentLang === 'ar' ? 'توكن تحليل مصاريف (AI)' : 'טוקני ניתוח הוצאות AI') }}</li>
              <li><i class="fa fa-shield"></i> {{ curentLang === 'en' ? 'Tax authority integration' : (curentLang === 'ar' ? 'ربط مع سلطة الضرائب' : 'חיבור לרשות המסים') }}</li>
            </ul>
            <a class="btn brand-btn w-100" routerLink="/register">
              {{ curentLang === 'en' ? 'Get started' : (curentLang === 'ar' ? 'ابدأ الآن' : 'התחל עכשיו') }}
            </a>
          </div>
        </div>
      </div>
      <p *ngIf="subscriptionPlans.length === 0" class="section-empty text-center text-muted py-4 mb-0">
        {{ curentLang === 'en' ? 'No subscription plans are available at the moment.' : (curentLang === 'ar' ? 'لا توجد خطط اشتراك متاحة حاليًا.' : 'אין תוכניות מנוי זמינות כרגע.') }}
      </p>
    </section>

    <!-- ═══════════════════════════════════════════ -->
    <!--  SECTION 2: Extensions (Doc + Company)      -->
    <!-- ═══════════════════════════════════════════ -->
    <section class="plans-section">
      <div class="section-header">
        <div class="section-icon ext-icon"><i class="fa fa-plus-circle"></i></div>
        <div>
          <h2 class="section-title">{{ curentLang === 'en' ? 'Extensions' : (curentLang === 'ar' ? 'التمديدات والإضافات' : 'הרחבות') }}</h2>
          <p class="section-desc">{{ curentLang === 'en' ? 'Need more documents or companies? Add them anytime to your existing plan.' : (curentLang === 'ar' ? 'تحتاج مستندات أو مصالح تجارية أكثر؟ أضفها في أي وقت لخطتك الحالية.' : 'צריך עוד מסמכים או חברות? הוסף אותם בכל עת לתוכנית הקיימת שלך.') }}</p>
        </div>
      </div>

      <div class="row g-4 justify-content-center">
        <!-- Doc extensions -->
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of docExtensionPlans">
          <div class="ext-card ext-card--doc">
            <div class="ext-card__icon"><i class="fa fa-files-o"></i></div>
            <h4 class="ext-card__name">{{ planName(plan) }}</h4>
            <p class="ext-card__desc" *ngIf="planDesc(plan)">{{ planDesc(plan) }}</p>
            <div class="ext-card__value">+{{ plan.extra_documents }}</div>
            <div class="ext-card__label">{{ curentLang === 'en' ? 'extra documents' : (curentLang === 'ar' ? 'مستند إضافي' : 'מסמכים נוספים') }}</div>
            <div class="ext-card__price">₪{{ plan.price | number:'1.0-0' }}</div>
            <a class="btn brand-btn-outline btn-sm w-100 mt-2" routerLink="/register">
              {{ curentLang === 'en' ? 'Sign up' : (curentLang === 'ar' ? 'إنشاء حساب' : 'הרשמה') }}
            </a>
          </div>
        </div>

        <!-- Company extensions -->
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of companyExtensionPlans">
          <div class="ext-card ext-card--company">
            <div class="ext-card__icon"><i class="fa fa-building"></i></div>
            <h4 class="ext-card__name">{{ planName(plan) }}</h4>
            <p class="ext-card__desc" *ngIf="planDesc(plan)">{{ planDesc(plan) }}</p>
            <div class="ext-card__value">+{{ plan.extra_companies }}</div>
            <div class="ext-card__label">{{ curentLang === 'en' ? 'extra companies' : (curentLang === 'ar' ? 'مصالح تجارية إضافية' : 'חברות נוספות') }}</div>
            <div class="ext-card__price">₪{{ plan.price | number:'1.0-0' }}</div>
            <a class="btn brand-btn-outline btn-sm w-100 mt-2" routerLink="/register">
              {{ curentLang === 'en' ? 'Sign up' : (curentLang === 'ar' ? 'إنشاء حساب' : 'הרשמה') }}
            </a>
          </div>
        </div>
      </div>
      <p *ngIf="docExtensionPlans.length === 0 && companyExtensionPlans.length === 0" class="section-empty text-center text-muted py-4 mb-0">
        {{ curentLang === 'en' ? 'No extension add-ons listed yet.' : (curentLang === 'ar' ? 'لا توجد تمديدات متاحة حاليًا.' : 'אין הרחבות זמינות כרגע.') }}
      </p>
    </section>

    <!-- ═══════════════════════════════════════════ -->
    <!--  SECTION 3: AI Expense Quota Plans          -->
    <!-- ═══════════════════════════════════════════ -->
    <section class="plans-section">
      <div class="section-header">
        <div class="section-icon ai-icon"><i class="fa fa-magic"></i></div>
        <div>
          <h2 class="section-title">
            {{ curentLang === 'en' ? 'AI Expense Analysis' : (curentLang === 'ar' ? 'تحليل المصاريف بالذكاء الاصطناعي' : 'ניתוח הוצאות בינה מלאכותית') }}
            <span class="ai-badge">AI</span>
          </h2>
          <p class="section-desc">
            {{ curentLang === 'en' ? 'Upload receipts and invoices — our AI automatically extracts, categorizes and analyzes your expenses. Save hours of manual data entry.' : (curentLang === 'ar' ? 'ارفع الفواتير والإيصالات — الذكاء الاصطناعي يستخرج ويصنّف ويحلل مصاريفك تلقائيًا. وفّر ساعات من الإدخال اليدوي.' : 'העלה קבלות וחשבוניות — ה-AI שלנו מחלץ, מסווג ומנתח את ההוצאות שלך אוטומטית. חסוך שעות של הזנה ידנית.') }}
          </p>
        </div>
      </div>

      <!-- AI Features strip -->
      <div class="ai-features-strip mb-4">
        <div class="ai-feature">
          <i class="fa fa-camera"></i>
          <span>{{ curentLang === 'en' ? 'Smart OCR scanning' : (curentLang === 'ar' ? 'مسح OCR ذكي' : 'סריקת OCR חכמה') }}</span>
        </div>
        <div class="ai-feature">
          <i class="fa fa-tags"></i>
          <span>{{ curentLang === 'en' ? 'Auto-categorization' : (curentLang === 'ar' ? 'تصنيف تلقائي' : 'סיווג אוטומטי') }}</span>
        </div>
        <div class="ai-feature">
          <i class="fa fa-bar-chart"></i>
          <span>{{ curentLang === 'en' ? 'Spending insights' : (curentLang === 'ar' ? 'تحليل الإنفاق' : 'תובנות הוצאות') }}</span>
        </div>
        <div class="ai-feature">
          <i class="fa fa-bolt"></i>
          <span>{{ curentLang === 'en' ? 'Instant processing' : (curentLang === 'ar' ? 'معالجة فورية' : 'עיבוד מיידי') }}</span>
        </div>
      </div>

      <div class="row g-4 justify-content-center">
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let plan of tokenExtensionPlans; let i = index">
          <div class="expense-card" [class.expense-card--featured]="i === 1">
            <div class="expense-card__ai-tag">
              <i class="fa fa-magic"></i> AI
            </div>
            <h4 class="expense-card__name">{{ planName(plan) }}</h4>
            <p class="expense-card__desc" *ngIf="planDesc(plan)">{{ planDesc(plan) }}</p>
            <div class="expense-card__quota">
              <span class="expense-card__quota-num">{{ (plan.extra_tokens ?? plan.documents_count) | number }}</span>
              <span class="expense-card__quota-label">{{ curentLang === 'en' ? 'Extra analysis tokens' : (curentLang === 'ar' ? 'توكنات تحليل إضافية' : 'טוקני ניתוח נוספים') }}</span>
            </div>
            <div class="expense-card__price">
              <span class="expense-card__currency">₪</span>
              <span class="expense-card__amount">{{ plan.price | number:'1.0-0' }}</span>
              <span class="expense-card__period">/ {{ curentLang === 'en' ? 'package' : (curentLang === 'ar' ? 'الباقة' : 'חבילה') }}</span>
            </div>
            <a class="btn brand-btn w-100 mt-3" routerLink="/register">
              {{ curentLang === 'en' ? 'Get started' : (curentLang === 'ar' ? 'ابدأ الآن' : 'התחל עכשיו') }}
            </a>
          </div>
        </div>
      </div>
      <p *ngIf="tokenExtensionPlans.length === 0" class="section-empty text-center text-muted py-4 mb-0">
        {{ curentLang === 'en' ? 'No AI expense packages available yet.' : (curentLang === 'ar' ? 'لا توجد باقات تحليل مصاريف بالذكاء الاصطناعي متاحة حاليًا.' : 'אין חבילות ניתוח הוצאות (AI) זמינות כרגע.') }}
      </p>
    </section>

    <!-- CTA Footer -->
    <div class="cta-footer text-center" *ngIf="!embedMode">
      <h3>{{ curentLang === 'en' ? 'Ready to get started?' : (curentLang === 'ar' ? 'مستعد للبدء؟' : 'מוכן להתחיל?') }}</h3>
      <p>{{ curentLang === 'en' ? 'Create your account now and start managing your business smartly.' : (curentLang === 'ar' ? 'أنشئ حسابك الآن وابدأ بإدارة عملك بذكاء.' : 'צור את החשבון שלך עכשיו והתחל לנהל את העסק שלך בחכמה.') }}</p>
      <div class="d-flex gap-3 justify-content-center flex-wrap">
        <a class="btn brand-btn btn-lg" routerLink="/register">
          <i class="fa fa-user-plus me-2"></i>{{ curentLang === 'en' ? 'Create account' : (curentLang === 'ar' ? 'إنشاء حساب' : 'צור חשבון') }}
        </a>
        <a class="btn brand-btn-outline btn-lg" routerLink="/login">
          <i class="fa fa-sign-in me-2"></i>{{ curentLang === 'en' ? 'Sign in' : (curentLang === 'ar' ? 'تسجيل الدخول' : 'התחבר') }}
        </a>
      </div>
    </div>

  </ng-container>
</div>
